<template>
    <div>
        <!-- <alert-notification v-if="notification_msg != ''" />   -->
        <loader v-if="pageLoader" />
        <div class="lightgrayBG selectWallet cap_exhange_cur">
            <div class="row">
                <div class="col-12 col-lg-7">
                    <div class="pt-1">
                        <label class="mb-2 semibold themecolor">Currency</label>
                        <select class="position-relative form-control copyCode" id="exampleFormControlSelect1" name="currency" required=""
                         v-model="currency" v-validate="'required'">
                            <option value="">Select Currency</option>
                            <option :value="list" v-for="list in fiatCurrencies1">{{list}}</option>
                        </select>
                        <span v-if="withdrawalReqSubmitted && errors.has('currency')" class="text-danger">{{ errors.first("currency") }}</span>
                    </div>
                    <div class="pt-4">
                        <label class="mb-2 semibold themecolor">Payment Methods</label>
                        <div class="d-flex border-radius-10 p-3 bg-white border">
                            <div
                                class="lightgrayBG d-flex greyIcon align-items-center justify-content-center rounded-circle ml-3 p-0">
                                <img src="../../../../static/website/images/bank.svg" alt="bank" width="28" height="29" class="img-fluid d-block" />
                            </div>
                            <div class="pl-4">
                                <label class="mb-2 semibold themecolor">Bank Account</label>
                                <p class="mb-0 f-12">
                                    Fill in your bank account details (all fields are mandatory) SWIFT OR SEPA transfers enabled and click on Add bank account to enable withdrawal.
                                </p>
                            </div>
                        </div>
                        <div class="d-flex border-radius-10 p-3 bg-white border align-items-center mt-4">
                            <div class="border-right pr-3 w-33 d-flex align-items-center">
                                <label class="semibold themecolor pr-3">Withdrawal Account </label>
                                <a href="javascript:void(0);"  class="d-block" @click="modal = 'eur-withdrawal-accounts'">
                                    <img src="../../../../static/website/images/down-arrow-blue.svg" alt="bank" width="15" height="10" class="img-fluid d-block" />
                                </a>
                            </div>
                            <div class="pl-3 border-right w-33" >
                                <input type="hidden" class="form-control border-0 h-auto py-0 pl-0" placeholder="Enter Amount" name="methodId" required=""  v-model="methodId" v-validate="{ required: true}"/>
                                
                                <input type="text" class="form-control border-0 h-auto py-0 pl-0" placeholder="please select method" v-if="Object.keys(selected_method).length == 0"/>
                                <p class="mb-0" v-if="Object.keys(selected_method).length > 0">Bank {{selected_method.bank_name}} - {{selected_method.beneficiary_name}} </p>
                                <span v-if="withdrawalReqSubmitted && errors.has('methodId')" class="text-danger">The withadrawal method is required</span>
                            </div>
                            <div class="pl-3 w-33">
                                <a href="javascript:void(0)" class="cap_btn addBankBtn secondaryBG" data-toggle="modal" data-target="#choosewithdrawalaccount"  @click="modal = 'add-bank'">+ Add New Bank Account</a>
                            </div>
                        </div>
                        <div class="d-flex border-radius-10 p-3 bg-white border align-items-center mt-4">
                            <div class="border-right pr-3 w-33">
                                <label class="semibold themecolor pr-2">Withdraw Amount</label>
                            </div>
                            <div class="pl-3 border-right w-33">
                                <input type="text" class="form-control border-0 h-auto py-0 pl-0" placeholder="Enter Amount" name="amount" required=""  v-model="amount" v-validate="{ required: true, decimal: 2, max_value: getMarginBalance}"/>
                                <span v-if="withdrawalReqSubmitted && errors.has('amount')" class="text-danger">{{ errors.first("amount") }}</span>
                                <span v-if="withdrawalReqSubmitted && (parseFloat(amount) < parseFloat(minimum_withdrawal_allowed))" class="text-danger">The minimum withdrawal amount is 10</span>
                            </div>
                            <div class="pl-3 w-33">
                                <label class="semibold themecolor">Balance: {{currencyIcon}}{{getMarginBalance}}</label>
                            </div>
                        </div>

                        <ul class="d-flex justify-content-end withdrawalPercentage mt-2">
                            <li @click="getAmount(25)">25%</li>
                            <li @click="getAmount(50)">50%</li>
                            <li @click="getAmount(75)">75%</li>
                            <li @click="getAmount(100)">100%</li>
                        </ul>
                    </div>
                    <div class="pt-5">
                        <a href="javascript:void(0)" class="cap_btn secondaryBG min-250" data-toggle="modal" data-target="#withdrawalconfirmation" @click="reviewWithdrawal()">Review Withdrawal</a>
                    </div>
                </div>
                <div class="col-12 col-lg-5">
                    <div class="pl-4">
                        <div class="d-flex">
                            <div class="mr-3">
                                <img src="../../../../static/website/images/caution.svg" alt="bank" width="31" height="28" class="img-fluid d-block caution" />
                            </div>
                            <div class="pt-1">
                                <span class="textcolor f-16">About Withdrawals</span>
                                <p class="pt-1 pb-2 mb-0 f-14">
                                    The name on the bank account you are withdrawing to must match the name on the account you are withdrawing from. Any fees applied by your
                                    bank to money transfers are not shown here.
                                </p>
                                <a href="javascript:void(0);" class="secondary medium">Learn more</a>
                            </div>
                        </div>
                        <div class="transactionDetails pt-5">
                            <label class="medium mb-2">Transaction Details:</label>
                            <div class="transactionElement border bg-white">
                                <div class="transactionFees border-bottom mb-3">
                                    <p class="mb-2 themecolor semibold">Transaction Fees</p>
                                    <p class="f-14 themecolor">{{transaction_fees * 100}}% fees applies</p>
                                </div>
                                <div class="transactionFees border-bottom mb-3">
                                    <p class="mb-2 themecolor semibold">Minimum Withdrawal</p>
                                    <p class="f-14 themecolor">{{currencyIcon}}{{minimum_withdrawal_allowed}}</p>
                                </div>
                                <div class="transactionFees mb-3">
                                    <p class="mb-2 themecolor semibold">Maximum Withdrawal</p>
                                    <p class="f-14 themecolor">{{currencyIcon}}100,000</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- bank-list -->
        <div   class="modal fade review" :class="(modal == 'eur-withdrawal-accounts')? 'show' : ''" v-if="modal == 'eur-withdrawal-accounts'">
            <div class="modal-dialog modal-dialog-centered max-800 min-500" role="document">
                <div class="modal-content">
                    <div class="p-4 border-bottom modal-header bg-none">
                        <h4 class="mb-0">EUR Withdrawal Accounts</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modal = ''">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body px-4">
                        <!---->
                        <div class="d-flex lightgrayBG border-radius-10 align-items-center p-2 justify-content-between mb-3" v-for="list in getBankData.records" @click="selected_method = list ; methodId = list.id" v-if="getBankData.totalRecords > 0">
                            <div class="d-flex">
                                <div class="mr-2 eurlogos">
                                    <img src="../../../../static/website/images/bank-one.svg" alt="bank" width="61" height="31" class="img-fluid d-block m-auto" />
                                </div>
                                <p class="mb-0 line-height-30">Bank {{list.bank_name}} | {{list.beneficiary_name}} card</p>
                            </div>
                            <div class="d-flex ml-2">
                                <img src="../../../../static/website/images/green-tick.svg" alt="bank" width="22" height="16" class="img-fluid d-block mr-2"  v-if="selected_method.id == list.id" />
                                <!-- <img src="../../../../static/website/images/edit.png" alt="bank" width="18" height="18" class="img-fluid d-block mr-2" @click.prevent="modal = 'edit-bank' ; editBankData = list"/> -->
                                <img src="../../../../static/website/images/trash.svg" alt="bank" width="16" height="18" class="img-fluid d-block" @click.prevent="modal = 'delete-bank' ; deleteBankData = list"/>
                            </div>
                        </div>
                        <pagination :totalRecords="getBankData.totalRecords" :limit="pageLimit" :pageNo="page" v-if="getBankData.totalRecords > parseInt(pageLimit)"></pagination>
                        <div class="d-flex align-items-center justify-content-center">
                            <a href="javascript:void(0)" class="cap_btn large_btn w-100 mt-3" data-toggle="modal" data-target="#withdrawalmessage" @click="modal = 'add-bank'">+ Add a payment method</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- add bank  -->
        <div  class="modal fade review" :class="(modal == 'add-bank')? 'show' : ''" v-if="modal == 'add-bank'">
            <div class="modal-dialog modal-dialog-centered max-800" role="document">
                <div class="modal-content">
                    <div class="p-4 border-bottom modal-header bg-none">
                        <h4 class="mb-0">Add new bank account</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modal = ''">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body px-4">
                       <add-bank :pageNameData="'withdrawalFiat'"></add-bank>
                    </div>
                </div>
            </div>
        </div>
        <!-- edit bank   -->
        <div  class="modal fade review" :class="(modal == 'edit-bank')? 'show' : ''" v-if="modal == 'edit-bank'">
            <div class="modal-dialog modal-dialog-centered max-800" role="document">
                <div class="modal-content">
                    <div class="p-4 border-bottom modal-header bg-none">
                        <h4 class="mb-0">Update Payment Detail</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modal = 'eur-withdrawal-accounts' ; editBankData = {}">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body px-4">
                        <edit-bank :bankData="editBankData" :pageNameData="'withdrawalFiat'"></edit-bank>
                    </div>
                </div>
            </div>
        </div>
        <!---delet payment method---->
        <div  class="modal fade review" :class="(modal == 'delete-bank')? 'show' : ''" v-if="modal == 'delete-bank' ">
            <div class="modal-dialog modal-dialog-centered max-800" role="document">
                <div class="modal-content">
                    <div class="p-4 border-bottom modal-header bg-none">
                        <h4 class="mb-0">Delete Payment Detail</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modal = 'eur-withdrawal-accounts' ; deleteBankData = {}">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body px-4">
                        <delete-bank :bankData="deleteBankData" :pageNameData="'withdrawalFiat'"></delete-bank>
                    </div>
                </div>
            </div>
        </div>
        <!-- Withdrawal Confirmation-->
        <div class="modal fade review" :class="(modal == 'confirm_withdrawal')? 'show' : ''" v-if="modal == 'confirm_withdrawal'">
            <div class="modal-dialog modal-dialog-centered max-800" role="document">
                <div class="modal-content" >
                    <div class="secondaryBG p-4 text-center modal-header">
                        <h4 class="mb-0 text-white">Withdrawal Confirmation</h4>
                    </div>
                    <div class="modal-body px-5" v-if="transaction_id == ''">
                        <h5 class="text-center my-2 medium d-block">Withdraw to Fiat</h5>
                        <h6 class="my-4 medium d-block">Withdrawal Instructions</h6>
                        <p class="mb-0 pb-4">
                            After clicking the withdrawal confirmation button, you will be
                            redirected to 2FA pannel for security code submission in context
                            to process your withdrawal
                        </p>
                        <ul class="s-convert border-top pt-3 mb-5">
                            <li class="d-flex align-items-center justify-content-between">
                                <p class="themecolor mb-0 semibold">Bank Account</p>
                                <p class="themecolor mb-0">{{selected_method.bank_name}} - {{selected_method.beneficiary_name}}</p>
                            </li>
                            <li class="d-flex align-items-center justify-content-between">
                                <p class="themecolor mb-0 semibold">Amount</p>
                                <p class="themecolor mb-0">{{currencyIcon}}{{amount}}</p>
                            </li>
                            <li class="d-flex align-items-center justify-content-between">
                                <p class="themecolor mb-0 semibold">Transaction Fees({{transaction_fees * 100}}%)</p>
                                <p class="themecolor mb-0">{{currencyIcon}}{{parseFloat(amount*transaction_fees).toFixed(2)}}</p>
                            </li>
                            <li class="d-flex align-items-center justify-content-between">
                                <p class="themecolor mb-0">
                                    <strong>Withdrawal Net Total</strong>
                                </p>
                                <p class="themecolor mb-0">
                                    <strong>{{currencyIcon}}{{parseFloat(amount - amount*transaction_fees).toFixed(2)}}</strong>
                                </p>
                            </li>
                        </ul>
                        <div class="d-flex align-items-center justify-content-center">
                            <a href="javascript:void(0)" class="cap_btn large_btn secondaryBG" data-toggle="modal" data-target="#withdrawalmessage" @click="fiatWithdrawal_req_otp()">Confirm Withdrawal</a>
                            <a href="javascript:void(0)" class="cap_btn large_btn border-btn-secondary ml-3" data-dismiss="modal" @click="modal = ''">Cancel</a>
                        </div>
                        <div class="d-flex align-items-center justify-content-center">
                            <p class="mt-4 semibold">Additional fees may be applied by the banking parties while processing the withdrawal.</p>
                        </div>
                    </div>
                    <div class="modal-body px-5" v-if="transaction_id != ''">
                        <div class="pt-3">
                            <label class="mb-2 semibold themecolor">2-Factor Authentication Code</label>
                            <input type="text" class="form-control" placeholder="" v-model="otp"  name="otp" required=""  v-validate="{ required: true, max :6 }" />
                            <span v-if="withdrawalSubmitted && errors.has('otp')" class="text-danger">{{ errors.first("otp") }}</span>
                        </div>
                        <div class="d-flex align-items-center justify-content-center mt-3">
                            <!-- <a href="javascript:void(0)" class="cap_btn large_btn secondaryBG" data-toggle="modal" data-target="#withdrawalmessage" @click="fiatWithdrawal_req_Resend_otp()">Resend Otp</a> -->
                            <a href="javascript:void(0)" class="cap_btn large_btn secondaryBG ml-3" data-toggle="modal" data-target="#withdrawalmessage" @click="fiatWithdrawal_req()">Confirm Withdrawal</a>
                            <a href="javascript:void(0)" class="cap_btn large_btn border-btn-secondary ml-3" data-dismiss="modal" @click="cancelwithdrawal()">Cancel</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Withdrawal Message -->
        <div  class="modal fade review"  :class="(modal == 'confirm_withdrawal_success')? 'show' : ''" v-if="modal == 'confirm_withdrawal_success'">
            <div class="modal-dialog modal-dialog-centered max-800" role="document">
                <div class="modal-content">
                    <div class="modal-body px-5">
                        <h3 class="text-center my-4 medium d-block line-height-normal">
                            Success! Your fiat withdrawal request has been submitted
                        </h3>
                        <div class="d-flex align-items-center justify-content-center">
                            <router-link to="/home" class="cap_btn large_btn border-btn ml-3" data-dismiss="modal">Go to Dashboard</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { depositWithdrawalMixins } from "@/plugins/depositWithdrawal";
  import { Const } from "@/plugins/vue-provider-cache/const.mod";
  import tradingMixins from "@/plugins/trading";

  import addBank from "../bank/add-bank";
  import editBank from "../bank/edit-bank";
  import deleteBank from "../bank/delete-bank";
  export default {
    name: "deposit-section",
    mixins: [depositWithdrawalMixins, tradingMixins],
    data() {
        return {
            pageLoader: false,
            modal : '',

            withdrawalReqSubmitted : false,
            currency : '',
            amount : '',
            account_id : '',
            act_account_id : '',
            transaction_fees : 0.01,
            methodId : '',

            editBankData : {},

            deleteBankData : {},

            withdrawalSubmitted : false,
            transaction_id : '',
            otp : '',

            selected_method : {},
            getMarginBalance : 0,
            page : '1',
            pageLimit : '10',

            fiatCurrencies : ['EUR','USD','AUD'],
            fiatCurrencies1 : [],
            currencyIcon : '',
            currencyIconJson :{'EUR' : '€','USD' : '$','GBP' : '£','CHF' : 'CHF','JPY' : '¥','AUD': '$'},
            minimum_withdrawal_allowed : 10
        };
    },
    components: {
       addBank, editBank, deleteBank
    },
    computed: {},
    watch: {
        currency(value) {
            this.account_id = this.tradingAccount[0].account_id
            this.currencyIcon = this.currencyIconJson[this.currency]
            this.tradingAccount[0].subAccounts.forEach((value) => {
                if (this.currency == value.currency) {
                    let num = 0;
                    this.act_account_id = value.act_account_id;
                    this.getMarginBalance = (this.marginInfoList[value.act_account_id]) ? this.marginInfoList[value.act_account_id].amount.toFixed(2) : num.toFixed(2)
                }
            });
        }
        // modal(value) {
        //     if(value != ''){
        //         document.body.classList.add('modalBody')
        //     }else{
        //         document.body.classList.remove('modalBody')
        //     }
        // }
    },
    methods: {
        checkBalanceExsitsInCurrency(){
            for(let i =0 ; i<=this.fiatCurrencies.length-1 ; i++){
                this.tradingAccount[0].subAccounts.forEach((value) => {
                    if (this.fiatCurrencies[i] == value.currency && this.marginInfoList[value.act_account_id] && this.marginInfoList[value.act_account_id].amount > 0) {
                        this.fiatCurrencies1.push(this.fiatCurrencies[i])
                    }
                });
            }
        },
        getAmount(getamount){
            this.amount = ((this.getMarginBalance * getamount)/100).toFixed(2)
        },
        listing() {
            let json = {
                globalParams: {
                    "filter": {"bank.status": "1"},
                    "sort": [],
                    "search": "",
                    "page": this.page,
                    "perPage": this.pageLimit,
                },
                localParams: { parameter: this, pagename : 'withdrawalFiat' },
            }
            this._runGetBankDetails(json);
        },
        reviewWithdrawal(){
            const _that  = this
            _that.withdrawalReqSubmitted = true;

            
            _that.$validator.validate().then((valid) => {
                if (valid && (parseFloat(_that.amount) >= parseFloat(_that.minimum_withdrawal_allowed))) {
                    _that.modal = 'confirm_withdrawal'
                }
            })
        },
        fiatWithdrawal_req_otp() {
            const _that  = this
            var inputJson = {
                globalParams: {
                    "account_id" : _that.account_id.toString(), 
                    "act_account_id" : _that.act_account_id.toString(), 
                    "amount" : _that.amount.toString(), 
                    "address" : "", 
                    "crypto" : _that.currency, 
                    "method_id" : _that.selected_method.id.toString(), 
                    "withdrawal_method" : '2'
                },
                localParams: { parameter: _that },
            };
            _that._runFiatWithdrawalRequestOtp(inputJson);
        },
        fiatWithdrawal_req_Resend_otp() {
            const _that  = this
            var inputJson = {
                globalParams: {
                    "trans_id": _that.transaction_id.toString()
                },
                localParams: { parameter: _that },
            };
            _that._runFiatWithdrawalRequestResendOtp(inputJson);
        },
        fiatWithdrawal_req(){
            const _that  = this
            _that.withdrawalSubmitted = true;
            _that.$validator.validate().then((valid) => {
                if (valid) {
                    var inputJson = {
                        globalParams: {
                            "otp": _that.otp,
                            "verify": "",
                            "trans_id": _that.transaction_id.toString()
                        },
                        localParams: { parameter: _that,  "account_id" : _that.account_id },
                    };
                    _that._runFiatWithdrawalRequest(inputJson);
                }
            })
        },
        cancelwithdrawal(){
            this.withdrawalSubmitted = false
            this.transaction_id = ''
            this.otp = ''
        },
        reset(){
            this.pageLoader= false
            // this.modal = ''
            
            this.withdrawalReqSubmitted = false
            this.currency = ''
            this.amount = ''
            this.account_id = ''
            this.act_account_id = ''
            this.transaction_fees = 0.01


            this.editBankData = {}

            this.deleteBankData = {}

            this.withdrawalSubmitted = false
            this.transaction_id = ''
            this.otp = ''

            this.selected_method = {}
            this.getMarginBalance = 0
        }
    },
    created() {
        this.listing()
        this.checkBalanceExsitsInCurrency()
    },
    // mounted () {
    //     if(this.modal != ''){
    //         alert()
    //         document.body.classList.add('bg-light')
    //     }else{
    //         alert('11')
    //         document.body.classList.remove('bg-light')
    //     }
    // }
  };
</script>


// WEBPACK FOOTER //
// src/components/website/deposit-withdrawal/withdrawal-fiat.vue